import React, { useContext, useEffect, useState } from 'react';
import { Container, Table, Button, Row, Col, Input, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label } from 'reactstrap';
import PaginationMaterial from "../../components/PaginationMaterial/PaginationMaterial";
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import Header from '../../components/Headers/Header';
import AdminNavbar from '../../components/Navbars/AdminNavbar/AdminNavbar';
import './UserType.css';
import Select from "react-select";
import { AuthContext } from '../../context/AuthContext';
import { ProdutoContext } from '../../context/ProdutoContext';
import { ProdutoType, CreateProdutoType, UpdateProdutoType } from '../../context/hooks/useProduto';
import useUser from '../../context/hooks/useUser';
import { createPermissionChecker, PermissionModule } from '../../types/permissions';

import { CreateProdutoModal } from '../../components/Produto/CreateProdutoModal';
import { EditProdutoModal  } from '../../components/Produto/EditProdutoModal';
import ModalConfirm from '../../components/ModalConfirm/ModalConfirm';

const Produto = () => {
    const { objUserTk } = useContext(AuthContext);
    const { listProduto, produtoPageCount, getAllProdutoPaged, createProduto, updateProduto, deleteProduto } = useContext(ProdutoContext);
    const { getPermissionsByUser, userPermissions, useLegacyPermissions, modulePermissions } = useUser();
    const hasPermission = createPermissionChecker(useLegacyPermissions, userPermissions, modulePermissions);

    const [editingProduto, setEditingProduto] = useState<UpdateProdutoType | null>(null);
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);

    const [loading, setLoading] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);

    const [filters, setFilters] = useState({
        name: '',
    });
    const [dataSearch, setDataSearch] = useState({ name: '' });

    useEffect(() => {
        setLoading(true);

        getAllProdutoPaged(1, 9, objUserTk.EmpresaId)
            .then(data => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao buscar produtos:", error);
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        const fetchPermissions = async () => {
            if (objUserTk?.UserId) {
                const permissions = await getPermissionsByUser(objUserTk.UserId);
            }
        };

        fetchPermissions().catch(error => console.error("Erro ao carregar permissões:", error));
    }, [objUserTk?.UserId]);

    const onChangePaginationCommon = async (e: any, value: any) => {
        await getAllProdutoPaged(value, 9, objUserTk.EmpresaId);
    };

    const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSearch = () => {
        setLoading(true);
        getAllProdutoPaged(1, 9, objUserTk.EmpresaId)
            .then(() => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao aplicar filtros:", error);
                setLoading(false);
            });
    };

    const handleClearFilters = () => {
        setFilters({ name: '' });
        setLoading(true);
        getAllProdutoPaged(1, 9, objUserTk.EmpresaId)
            .then(() => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao liimpar filtros:", error);
                setLoading(false);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleEditProduto = (produto: ProdutoType) => {
        setEditingProduto(produto);
        setEditModalOpen(true);
    };

    const [confirmDeleteProdutoId, setConfirmDeleteProdutoId] = useState<number | null>(null);

    const handleDeleteProduto = (produtoId: number) => {
        setConfirmDeleteProdutoId(produtoId);
    };

    const executeDeleteProduto = () => {
        if (confirmDeleteProdutoId == null) return;
        deleteProduto(confirmDeleteProdutoId)
            .then(deletedProduto => {
                if (!deletedProduto) console.error("Erro ao excluir produto.");
                getAllProdutoPaged(1, 9, objUserTk.EmpresaId);
            })
            .catch(error => console.error("Erro ao excluir produto:", error));
        setConfirmDeleteProdutoId(null);
    };

    return (
        <>
            <LoadingSpinner />
            <Header />
            <AdminNavbar
                brandText={"Conta Pagar"}
                search={false}
                titleSearch={""}
            />

            <Container className="mt-5">
                <Row className="align-items-center mb-4">
                    {/* <Col xs="12" md="9" lg="9" className="mb-2">
                        <Input
                            className="form-control-alternative"
                            type="text"
                            name="name"
                            id="name"
                            placeholder="Buscar por nome da categoria"
                            value={dataSearch.name}
                            onChange={handleFilterChange}
                        />
                    </Col>
                    <Col xs="12" md="3" lg="3" className="d-flex justify-content-start justify-content-md-end mb-2">
                        <Button
                            style={{ color: "#FFF", backgroundColor: "#585858" }}
                            type="button"
                            size="m"
                            onClick={handleSearch}
                            className="mr-2"
                        >
                            Buscar
                        </Button>
                        <Button
                            style={{ color: "#FFF", backgroundColor: "#d9534f" }}
                            type="button"
                            size="m"
                            onClick={handleClearFilters}
                        >
                            Limpar
                        </Button>
                    </Col> */}

                    {hasPermission(PermissionModule.Produtos, 1) && (
                        <Col xs="12" className="text-right mt-3">
                            <Button
                                style={{ color: "#FFF", backgroundColor: "#585858" }}
                                className="btn-filter"
                                onClick={() => setCreateModalOpen(true)}
                            >
                                Adicionar produto
                            </Button>
                        </Col>
                    )}
                </Row>

                {hasPermission(PermissionModule.Produtos, 2) ? (
                    <Row className="mt-4">
                        <Col>
                            <Table hover responsive className="table-striped custom-table">
                                <thead>
                                    <tr>
                                        <th>Sequência</th>
                                        <th>Nome</th>
                                        <th>Descrição</th>
                                        <th>Valor</th>
                                        <th>Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listProduto.map((produto: ProdutoType, index: number) => {
                                        return (
                                            <tr key={index}>
                                                <td>{produto.id}</td>
                                                <td>{produto.name}</td>
                                                <td>{produto.description}</td>
                                                <td>{produto.value?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                                <td>
                                                    {hasPermission(PermissionModule.Produtos, 3) && (
                                                        <Button onClick={() => { handleEditProduto(produto) }}><i className="fa-solid fa-pen-to-square"></i></Button>
                                                    )}
                                                    {hasPermission(PermissionModule.Produtos, 4) && (
                                                        <Button onClick={() => handleDeleteProduto(produto.id)} color="danger"><i className="fa-solid fa-trash"></i></Button>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                            <div className="d-flex justify-content-end mt-3">
                                {produtoPageCount && (
                                    <div className="d-flex justify-content-center mt-4">
                                        <PaginationMaterial
                                            onChange={(e: any, value: any) => onChangePaginationCommon(e, value)}
                                            count={produtoPageCount}
                                        />
                                    </div>
                                )}
                                {listProduto.length === 0 && (
                                    <div style={{ color: "red" }}>NÃO FOI ENCONTRADO NENHUM REGISTRO</div>
                                )}
                            </div>
                        </Col>
                    </Row>
                ) : (
                    <Row className="mt-4">
                        <Col>
                            <div style={{ color: "red", textAlign: "center" }}>
                                Você não tem permissão para visualizar os produtos.
                            </div>
                        </Col>
                    </Row>
                )}
            </Container>

            <CreateProdutoModal
                isOpen={createModalOpen}
                toggle={() => setCreateModalOpen(false)}
                onCreated={() => getAllProdutoPaged(1, 9, objUserTk.EmpresaId)}
            />

            <EditProdutoModal
                isOpen={editModalOpen}
                toggle={() => setEditModalOpen(false)}
                conta={editingProduto}
                onUpdated={() => getAllProdutoPaged(1, 9, objUserTk.EmpresaId)}
            />

            <ModalConfirm
                openModal={confirmDeleteProdutoId !== null}
                closeModal={() => setConfirmDeleteProdutoId(null)}
                handleConfirm={executeDeleteProduto}
                title="Excluir produto"
                message="Tem certeza que deseja excluir este produto? Esta ação não pode ser desfeita."
            />
        </>
    );
};

export default Produto;